module.exports = __webpack_public_path__ + "static/deden-ddd4b73c4e39b5c29590ef79d7e4f501.png";